import React from "react";
import PropTypes from "prop-types";
import { Card, CardContent, Typography, Box } from "@mui/material";
import GaugeChart from "react-gauge-chart";

const PerformanceGaugeCard = ({
  title,
  percent,
  width = 200,
  arcWidth = 0.2,
  arcPadding = 0,
  textColor = "#000",
  needleColor = "#333",
  needleBaseColor = "#333",
  gaugeStyle = { width: "100%", maxWidth: width, height: 100},
}) => {
  return (
    // <Card sx={{ width: "100%", maxWidth: 450, height: "auto", p: 2, textAlign: "center" }}>
    <Box display="flex" flexDirection="column" alignItems="center" width="100%" height="100%">
      <Typography variant="h6" fontWeight="bold"  >
        {title}
      </Typography>
      <CardContent
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box display="flex" justifyContent="center" alignItems="center">
          <GaugeChart
            id="performance-gauge"
            nrOfLevels={70}
            arcWidth={arcWidth}
            arcPadding={arcPadding}
            percent={percent}
            colors={["#FF5F00", "#FFDD00", "#00B100"]}
            animate={false}
            textColor={textColor}
            needleColor={needleColor}
            needleBaseColor={needleBaseColor}
            style={gaugeStyle}
          />
        </Box>
      </CardContent>
      {/* </Card> */}
    </Box>
  );
};

PerformanceGaugeCard.propTypes = {
  title: PropTypes.string.isRequired,
  percent: PropTypes.number.isRequired,
  width: PropTypes.number,
  arcWidth: PropTypes.number,
  arcPadding: PropTypes.number,
  textColor: PropTypes.string,
  needleColor: PropTypes.string,
  needleBaseColor: PropTypes.string,
  gaugeStyle: PropTypes.object,
};

export default PerformanceGaugeCard;
